import React, { useState, useEffect } from "react";
import { Eye, Edit3, Trash, ChevronDown, ChevronUp } from "lucide-react";
import OpportunityDetails from "../components/OpportunityDetails";
import OpportunityForm from "../components/OpportunityForm";
import AddEditActivityModal from "../../Activities/pages/AddEditActivityModal";
import { fetchOpportunities, createOpportunity, updateOpportunity, deleteOpportunity } from "../api/OpportunityService";
import { fetchPipelineStages, fetchOpportunityStatuses } from "../api/OpportunityService";
import { fetchActivitiesByOpportunity } from "../../Activities/api/activityService";
import { fetchBranches } from "../../../common/api/branchService";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import DataTable from '../components/DataTable';
import { sortData } from "../utils/sortUtils"; // Add this utility

function OpportunitiesPage() {
 
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [expandedOpportunityId, setExpandedOpportunityId] = useState(null);
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [isEditingActivity, setIsEditingActivity] = useState(false);
  const [pipelineStages, setPipelineStages] = useState([]);
  const [opportunityStatuses, setOpportunityStatuses] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [stageFilter, setStageFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [branchFilter, setBranchFilter] = useState([]);
  const [opportunityActivities, setOpportunityActivities] = useState({});
  const [activeOpportunityForActivity, setActiveOpportunityForActivity] = useState(null); // Separate state for Add Activity modal
  const [isEditing, setIsEditing] = useState(false);
  const [expandedOpportunities, setExpandedOpportunities] = useState({});
  const [branches, setBranches] = useState([]);
 

// Access currency symbol and code from .env
const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || "$"; // Fallback to "$" if not defined
const currencyCode = process.env.REACT_APP_CURRENCY_CODE || "USD"; // Fallback to "USD" if not defined

useEffect(() => {
  const loadOpportunities = async () => {
    try {
      console.log('Before Fetch Opportunities in page');
      const data = await fetchOpportunities();
      console.log('Load Opportunities Frontend :',data);
      setOpportunities(data);
    } catch (error) {
      console.error("Error loading opportunities:", error);
    } finally {
      setLoading(false);
    }
  };

  loadOpportunities();
}, []);

const animatedComponents = makeAnimated();
const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '44px',
    borderColor: '#e5e7eb',
    borderRadius: '8px',
    zIndex: 20,
    '&:hover': { borderColor: '#93c5fd' },
    '&:focus-within': { borderColor: '#3b82f6', boxShadow: '0 0 0 1px #3b82f6' }
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f2fe',
    borderRadius: '6px',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#0369a1',
    fontWeight: '500',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#0369a1',
    ':hover': { backgroundColor: '#bae6fd', color: '#075985' }
  }),
  menu: (provided) => ({
    ...provided,
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
  })
};
  
    

useEffect(() => {
  const loadFilters = async () => {
    try {
      console.log("Fetching pipeline stages...");
      const stages = await fetchPipelineStages();
      console.log("Pipeline stages:", stages);

      console.log("Fetching opportunity statuses...");
      const statuses = await fetchOpportunityStatuses();
      console.log("Opportunity statuses:", statuses);

      const branches = await fetchBranches();

      setBranches(Array.isArray(branches) ? branches : branches[0] || []);
      // ✅ Ensure it's an array
      setPipelineStages(Array.isArray(stages) ? stages : stages[0] || []);
      //setPipelineStages(Array.isArray(stages) ? stages : []);
      setOpportunityStatuses(Array.isArray(statuses) ? statuses : statuses[0] || []);
    } catch (error) {
      console.error("❌ Error fetching filters:", error);
      setPipelineStages([]);
      setOpportunityStatuses([]);
      setBranches([]);
    }
  };

  loadFilters();
}, []);

const handleSort = (key) => {
  setSortConfig((prev) => ({
    key,
    direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
  }));
};

const loadActivities = async (opportunityId) => {
  if (!opportunityId) {
    console.error("❌ Error: Undefined opportunityId passed to loadActivities!");
    return;
  }

  try {
    console.log("📡 Fetching activities for Opportunity ID:", opportunityId);
    const activities = await fetchActivitiesByOpportunity(opportunityId);
    
    if (!activities) {
      console.warn(`⚠️ Warning: No activities found for Opportunity ID: ${opportunityId}`);
    }

    setOpportunityActivities((prev) => ({
      ...prev,
      [opportunityId]: activities || [],
    }));
  } catch (error) {
    console.error("❌ Error fetching activities for Opportunity ID:", opportunityId, error);
  }
};
  // Mapping pipeline stages to progress percentages
  const stageProgress = {
    New: 0,
    "Proposal Sent": 25,
    Negotiation: 50,
    "Closed - Won": 100,
  };

  // Add new opportunity
  /*const handleAddOpportunity = async (newOpportunity) => {
    try {
      const createdOpportunity = await createOpportunity(newOpportunity);
    setSuccessMessage(`Opportunity "${createdOpportunity.opportunity_name}" created successfully!`);

    // ✅ Update the state immediately
    setOpportunities((prevOpportunities) => [...prevOpportunities, createdOpportunity]);
    // Auto-hide message after 3 seconds
    setTimeout(() => setSuccessMessage(""), 3000);

      // Remove manual state update
      const updatedData = await fetchOpportunities(); // Re-fetch all opportunities
      setOpportunities(updatedData);
      setIsFormOpen(false);
    } catch (error) {
      console.error("Error adding opportunity:", error);
    }
  };*/

<OpportunityForm
  opportunity={selectedOpportunity}
  onClose={() => {
    setIsFormOpen(false);
    setSelectedOpportunity(null);
  }}
  onSave={(newOpportunity) => {
    if (newOpportunity && newOpportunity.opportunity_id) {
      setOpportunities((prevOpportunities) => {
        const exists = prevOpportunities.some(opp => opp.opportunity_id === newOpportunity.opportunity_id);
        return exists ? prevOpportunities : [...prevOpportunities, newOpportunity];
      });
    }
  }}
/>

  // Update opportunity status
  const handleUpdateStatus = (id, newStatus) => {
    setOpportunities((prevOpportunities) =>
      prevOpportunities.map((opp) =>
        opp.id === id ? { ...opp, status: newStatus } : opp
      )
    );

    // If the selected opportunity is being updated, reflect the change
    if (selectedOpportunity?.id === id) {
      setSelectedOpportunity((prev) => ({ ...prev, status: newStatus }));
    }
  };

  // Edit opportunity
  const handleEditOpportunity = async (updatedOpportunity) => {
    try {
      const editedOpportunity = await updateOpportunity(updatedOpportunity.id, updatedOpportunity);
      setOpportunities(
        opportunities.map((opp) =>
          opp.id === updatedOpportunity.id ? editedOpportunity : opp
        )
      );
      setIsFormOpen(false);
    } catch (error) {
      console.error("Error editing opportunity:", error);
    }
  };

  // Delete opportunity
  const handleDeleteOpportunity = async (opportunity_id) => {
    if (!opportunity_id) {
      console.error("❌ Error: opportunity_id is missing or undefined!");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this opportunity?")) return;

     
    try {
      console.log("🗑️ Deleting Opportunity ID:", opportunity_id);
      await deleteOpportunity(opportunity_id);
      setOpportunities((prevOpportunities) =>
        prevOpportunities.filter((opp) => opp.opportunity_id !== opportunity_id)
      );
      console.log("✅ Opportunity deleted successfully!");
    } catch (error) {
      console.error("Error deleting opportunity:", error);
    }
  };

  // Open form for Add/Edit
  const openForm = (opportunity = null) => {
    setSelectedOpportunity(opportunity);
    setIsFormOpen(true);
  };

  // Close form
  const closeForm = () => {
    setIsFormOpen(false);
    setSelectedOpportunity(null);
  };

  // Toggle expand/collapse for pipeline stages and activities
  // ✅ Store expanded states as an object

  const toggleExpand = async (opportunityId) => {
    console.log('OpportunityId : ', opportunityId);
    if (!opportunityId) {
      console.error("❌ Error: Undefined opportunityId in toggleExpand!");
      return;
    }
  
    console.log(`🔄 Toggling Expand for Opportunity ID: ${opportunityId}`);
  
    // ✅ Toggle expansion state
    setExpandedOpportunityId((prevId) => {
      const newId = prevId === opportunityId ? null : opportunityId;
      console.log(`New expandedOpportunityId: ${newId}`);
      return newId;
    });
  
    // ✅ Load activities only if they haven't been fetched
    if (!opportunityActivities[opportunityId]) {
      console.log(`📡 Fetching activities for Opportunity ID: ${opportunityId}`);
      await loadActivities(opportunityId);
    }
  };
  // Handle Activity Actions
  const handleAddActivity = (opportunity, event) => {
    event.stopPropagation(); // Prevent triggering the parent row's onClick
    setSelectedActivity(null); // Clear any previously selected activity
    setActiveOpportunityForActivity(opportunity); // Set the opportunity for the modal
    setIsEditingActivity(false); // Add new activity mode
    setIsActivityModalOpen(true); // Open the activity modal
  };

  const handleEditActivity = (opportunity, activity, event) => {
    event.stopPropagation(); // Prevent triggering the parent row's onClick
    setSelectedActivity(activity); // Set the selected activity for editing
    setActiveOpportunityForActivity(opportunity); // Set the opportunity for the modal
    setIsEditingActivity(true); // Edit mode
    setIsActivityModalOpen(true); // Open the activity modal
  };

  const handleDeleteActivity = (opportunityId, activityId, event) => {
    event.stopPropagation(); // Prevent triggering the parent row's onClick
    setOpportunities((prevOpportunities) =>
      prevOpportunities.map((opportunity) =>
        opportunity.opportunity_id=== opportunityId
          ? {
              ...opportunity,
              activities: opportunity.activities.filter(
                (activity) => activity.id !== activityId
              ),
            }
          : opportunity
      )
    );
  };

  const handleSaveActivity = (opportunityId, activity) => {
    setOpportunities((prevOpportunities) =>
      prevOpportunities.map((opportunity) =>
        opportunity.opportunity_id === opportunityId
          ? {
              ...opportunity,
              activities: activity.id
                ? opportunity.activities.map((act) =>
                    act.id === activity.id ? activity : act
                  )
                : [
                    ...opportunity.activities,
                    { ...activity, id: opportunity.activities.length + 1 },
                  ],
            }
          : opportunity
      )
    );
    setIsActivityModalOpen(false); // Close the modal
    setActiveOpportunityForActivity(null); // Clear active opportunity
  };

  const handleCloseActivityModal = () => {
    setIsActivityModalOpen(false);
    setSelectedActivity(null); // Clear selected activity
    setActiveOpportunityForActivity(null); // Clear active opportunity
    setSelectedOpportunity(null); // Clear selected opportunity
  };

  // Filter opportunities based on search query, stage, and status
  const filteredOpportunities = opportunities.filter(opportunity =>
    (`${opportunity.opportunity_name}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
      opportunity.product_service?.toLowerCase().includes(searchQuery.toLowerCase())) &&
    (stageFilter.length === 0 || stageFilter.some(filter => filter.value === opportunity.PipelineStage?.name)) &&
    (statusFilter.length === 0 || statusFilter.some(filter => filter.value === opportunity.OpportunityStatus?.name)) &&
    (branchFilter.length === 0 || branchFilter.some(filter => filter.value === opportunity.Branch?.name))
  );
  
  const sortedOpportunities = sortData(filteredOpportunities, sortConfig).map(opportunity => ({
    ...opportunity,
    id: opportunity.opportunity_id
  }));

    /*const matchesStage =
      !stageFilter || opportunity.pipeline_stage === stageFilter;

    const matchesStatus = !statusFilter || opportunity.status === statusFilter;

    return matchesSearch && matchesStage && matchesStatus;
  });*/

  return (
    <div className="relative flex flex-col h-screen ">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
  <h2 className="text-lg md:text-2xl font-semibold text-gray-800 mb-2 md:mb-0">
    Opportunities
  </h2>
  <button
    className="bg-blue-600 text-white px-3 py-2 text-sm rounded-md hover:bg-blue-500"
    onClick={() => openForm()}
  >
     + Add Opportunity
  </button>
</div>
      {/* Search and Filters */}
      {/* Search and Filters */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-8 relative z-20">
  <input
    type="text"
    placeholder="🔍 Search Opportunities..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="border p-2 rounded-md w-full"
  />
  {/* Stage Filter */}
  {/*<Select
    isMulti
    options={pipelineStages.map(stage => ({ value: stage.name, label: stage.name }))}
    value={stageFilter}
    onChange={setStageFilter}
    components={animatedComponents}
    placeholder="Filter by Stage"
    styles={customStyles}
    closeMenuOnSelect={false}
    noOptionsMessage={() => "No stages found"}
    className="react-select-container"
    classNamePrefix="react-select"
  /> */}
  {/* Branch Filter */}
  <Select
    isMulti
    options={branches.map(branch => ({ value: branch.name, label: branch.name }))}
    value={branchFilter}
    onChange={setBranchFilter}
    components={animatedComponents}
    placeholder="Filter by Branch"
    styles={customStyles}
    closeMenuOnSelect={false}
    noOptionsMessage={() => "No branch found"}
    className="react-select-container"
    classNamePrefix="react-select"
  />
  {/* Status Filter */}
  <Select
    isMulti
    options={opportunityStatuses.map(status => ({ value: status.name, label: status.name }))}
    value={statusFilter}
    onChange={setStatusFilter}
    components={animatedComponents}
    placeholder="Filter by Status"
    styles={customStyles}
    closeMenuOnSelect={false}
    noOptionsMessage={() => "No statuses found"}
    className="react-select-container"
    classNamePrefix="react-select"
  />
  
</div>
      {/* Opportunity List */}
      <DataTable
  columns={[
    {
      key: 'opportunity_name',
      header: 'Opportunity Name',
      sortable: true
    },
    {
      key: 'Branch.name',
      header: 'Branch Name',
      sortable: true,
      render: (row) => row.Branch?.name || "N/A"
    },
    {
      key: 'OpportunityStatus.name',
      header: 'Status',
      sortable: true,
      render: (row) => row.OpportunityStatus?.name || "N/A"
    },
    /*{
      key: 'PipelineStage.name',
      header: 'Pipeline Stage',
      sortable: true,
      render: (row) => row.PipelineStage?.name || "N/A"
    },*/
    {
      key: 'progress',
      header: 'Progress',
      sortable: false,
      render: (row) => (
        <div className="relative w-24 h-3 bg-gray-200 rounded-full">
          <div
            className="h-full rounded-full"
            style={{
              width: `${stageProgress[row.pipeline_stage]}%`,
              backgroundColor: "#3b82f6",
            }}
          />
        </div>
      )
    },
    {
      key: 'estimated_value',
      header: 'Estimated Value',
      sortable: true,
      render: (row) => `${currencySymbol}${row.estimated_value}` // Use currency symbol from .env
    },
    {
      key: 'actions',
      header: 'Actions',
      sortable: false,
      render: (row) => (
        <div className="flex items-center justify-center space-x-1">
          <button
                onClick={(event) => {
                  event.stopPropagation(); // Prevent parent onClick
                  setSelectedOpportunity(row);
                }}
            className="text-blue-600 hover:text-blue-800 p-1"
          >
            <Eye size={14} />
          </button>
          <button

onClick={(event) => {
  event.stopPropagation(); // Prevent parent onClick
  setIsEditing(true);
  setSelectedOpportunity(row);
  setIsFormOpen(true);
}}
            className="text-green-600 hover:text-green-800 p-1"
          >
            <Edit3 size={14} />
          </button>
          <button
                onClick={(event) => {
                  event.stopPropagation(); // Prevent parent onClick
                  handleDeleteOpportunity(row.id);
                }}
            className="text-red-600 hover:text-red-800 p-1"
          >
            <Trash size={14} />
          </button>
          <button
  onClick={(event) => {
    event.stopPropagation(); // Prevent parent onClick
    toggleExpand(row.id);
  }}
  className="text-gray-600 hover:text-gray-800 p-1"
>
  {expandedOpportunityId === row.id ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
</button>
        </div>
      )
    }
  ]}
  data={sortedOpportunities}
  sortConfig={sortConfig}
  onSort={handleSort}
  renderExpandedRow={(row) => (
    <div className="space-y-2 p-4">
    <div>
      <h4 className="font-semibold">Pipeline Stages:</h4>
      <div className="flex space-x-4">
        {pipelineStages.map((stage) => {
          console.log("Pipeline Stage:", stage.name, "Row Pipeline Stage:", row.pipeline_stage);
          return (
            <div
              key={stage.name}
              className={`px-2 py-1 rounded ${
                stage.name === row.PipelineStage?.name
                  ? "bg-blue-500 text-white" // Highlight the current stage
                  : "bg-gray-200 text-gray-800" // Default style for other stages
              }`}
            >
              {stage.name}
            </div>
          );
        })}
      </div>
    </div>
      {opportunityActivities[row.id]?.length > 0 ? (
        <div className="bg-gray-50 p-4 rounded-lg shadow-md">
          <h3 className="text-md font-semibold text-gray-700 mb-2">Activities:</h3>
          <table className="min-w-full bg-white border border-gray-200 rounded-md">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Type</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Summary</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Date</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Status</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {opportunityActivities[row.id].map(activity => (
                <tr key={activity.id} className="border-t border-gray-200">
                  <td className="px-4 py-2 text-sm text-gray-800">{activity.type}</td>
                  <td className="px-4 py-2 text-sm text-gray-600">{activity.summary}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{activity.date}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{activity.status}</td>
                  <td className="px-4 py-2 flex space-x-2">
                    <button
                      onClick={() => {
                        setSelectedActivity(activity);
                        setIsEditingActivity(true);
                        setIsActivityModalOpen(true);
                      }}
                      className="text-blue-600 hover:text-blue-800"
                    >
                      <Edit3 size={16} />
                    </button>
                    <button
                      onClick={() => handleDeleteActivity(row.id, activity.id)}
                      className="text-red-600 hover:text-red-800"
                    >
                      <Trash size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500">No activities found.</p>
      )}
      <button
        onClick={() => {
          setSelectedOpportunity(row);
          setIsActivityModalOpen(true);
          setIsEditingActivity(false);
        }}
        className="text-blue-600 hover:underline mt-2"
      >
        Add Activity
      </button>
    </div>
  )}
  expandedRowId={expandedOpportunityId} // ✅ Use expandedOpportunityId
/>
{/* Opportunity Details */}
{selectedOpportunity && !isFormOpen && !isActivityModalOpen && (
  <OpportunityDetails
    opportunity={selectedOpportunity}
    onClose={() => setSelectedOpportunity(null)}
    onEdit={openForm}
    onUpdateStatus={handleUpdateStatus}
    onDelete={handleDeleteOpportunity}
  />
)}

      {/* Add/Edit Opportunity Form */}
      {isFormOpen && (
        <OpportunityForm
          opportunity={selectedOpportunity}
          onClose={() => {
            setIsFormOpen(false);
            setSelectedOpportunity(null);
    }}
    onSave={(newOpportunity) => {
      if (newOpportunity && newOpportunity.opportunity_id) {
        setOpportunities((prevOpportunities) => [...prevOpportunities, newOpportunity]);
      }
    }}
        />
      )}

      {/* Activity Modal */}
      {isActivityModalOpen && (
  <AddEditActivityModal
    isOpen={isActivityModalOpen}
    onClose={handleCloseActivityModal}
    onSave={(activity) =>
      handleSaveActivity(activeOpportunityForActivity.id, activity)
    }
    isEditing={isEditingActivity}
    activity={selectedActivity}
  />
)}

<AddEditActivityModal
  isOpen={isActivityModalOpen}
  onClose={() => {
    setIsActivityModalOpen(false);
    setSelectedActivity(null); // Clear selected activity
    setActiveOpportunityForActivity(null); // Clear active opportunity
  }}
  onSave={(activity) => handleSaveActivity(activeOpportunityForActivity.id, activity)}
  isEditing={isEditingActivity}
  activity={selectedActivity}
/>
    </div>
  );
}

export default OpportunitiesPage;